import { ArnNftCache } from './ArnNftCache';

export class ArnNftContext {
  constructor(readonly cache = new ArnNftCache()) {}
}
